import { onCommonDeployError, setDeploymentRequestLoading } from "../../../basic/_fetch/_fetchHelpers";
import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { dispatchNotification } from "../../../../../layouts/app/components/notificationSystem/notifications";
import { API_BUILDER_PROJECT_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function projectCompose({
                                   onSuccess,
                                   onError,
                                   deploymentID,
                                   compose,
                               }) {


    if (typeof deploymentID !== 'number' || !compose) {
        dispatchNotification({
            message: 'Invalid data provided',
            type: 'error',
        });
        return;
    }

    const url = `${API_BUILDER_PROJECT_NODE}?project=${deploymentID}&compose=true`;

    setDeploymentRequestLoading(true);

    createFetch({
        URL: url,
        method: 'GET',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            setDeploymentRequestLoading(false);
            if (onError) onError(response);
            onCommonDeployError(response);
        },
    });
}